module.exports = __webpack_public_path__ + "media/contract/dotted-line-3-6b8abcff.png";